export default __webpack_public_path__ + "static/media/right_sidebar_arrow.4f1680f8.svg";